import React, { useEffect, useState } from "react";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import Notification from "../../elements/notification/Notification";
import DefaultButton from "../../styles/materialButtonStyle";
import MaterialDialog from "../../styles/materialDialog";
import ProjectsSelect from "../../elements/projects/ProjectsSelect";
import { TextField } from "@material-ui/core";
import axios from "axios";
import { useTranslation } from "react-i18next";
import ServicesSelect from "../../connectedServices/client/ServicesSelect";
import DocumentVerificationSchemaSelect from "../../elements/documentSchema/DocumentVerificationSchemaSelect";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import { StyledChangeServiceVerificationWrapper } from "../styledVerificationSchema";

const VerificationSchemaEdit = ({ fetch, setFetch }) => {
  const { t } = useTranslation("verificationSchemaPage");
  const [open, setOpen] = useState(false);

  const defaultData = {
    "project": null,
    "service": null,
    "schema": null
  };

  const [invoiceData, setInvoiceData] = useState(defaultData);
  const [disabled, setDisabled] = useState(false);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    setDisabled(false);
  }, [notification]);

  const updateService = async () => {
    setDisabled(true);

    let check2Fa = await check2FA(getUserInfo()["userId"], invoiceData.twofa);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.get(`/api/change-project-verification-schemas/${invoiceData.project.id}/${invoiceData.service.id}/${invoiceData.schema}`, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setNotification(
          { ...notification, visible: true, type: "success", message: t("changeService.success") });
      }
      setFetch(!fetch);
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => handleClose());
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setInvoiceData(defaultData);
    setOpen(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledChangeServiceVerificationWrapper className="verification-schema-head__change-service">
        <DefaultButton
          color="success"
          onClick={handleClickOpen}
        >
          {t("changeService.title")}
        </DefaultButton>
        <MaterialDialog
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("changeService.description")}
            </StyledDialogHead>
            <StyledDialogContent>
              <ProjectsSelect
                checkedProjects={invoiceData.project}
                setCheckedProjects={(data) => setInvoiceData({ ...invoiceData, "project": data })}
                isObject={true}
                userId={getUserInfo()["userId"]}
              />
              <ServicesSelect
                checkedService={invoiceData.service}
                setCheckedService={(data) => setInvoiceData({ ...invoiceData, "service": data, page: 1 })}
              />
              <DocumentVerificationSchemaSelect
                checkedDocumentFlow={invoiceData.schema}
                setCheckedDocumentFlow={(data) => setInvoiceData({ ...invoiceData, "schema": data })}
                isObject={true}
                defaultOption={false}
              />
              <TextField
                id="twofa"
                label={t("changeService.twoFa")}
                value={invoiceData.twofa}
                onChange={(data) => setInvoiceData({ ...invoiceData, "twofa": data.target.value })}
              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
                disabled={disabled}
              >
                {t("changeService.cancel")}
              </DefaultButton>
              <DefaultButton
                onClick={updateService}
                color="success"
                disabled={disabled}
              >
                {t("changeService.change")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </StyledChangeServiceVerificationWrapper>
    </>
  );
};

export default VerificationSchemaEdit;